// 统一处理 API 错误，特别是 token 过期场景
import store from '@/store/store'; // 请确保路径正确
import router from '@/router';
import myJsTools from '@/utils/myJsTools';
import { Toast } from "vant";

/**
 * 获取worker轮询基础配置
 * @param {*} options 入参
 * @returns 
 */
export const getFetchParamsConfig = (options={}) => {
    const token_info = myJsTools.getItem("token_info");
    const config = {
        baseURL: process.env.VUE_APP_API_URL,
        token: token_info?.token,
        hosId: token_info?.hosId,
        ...options
    }
    return config;
}

// 防止重复跳转登录页
let redirectPending = false;

/**
 * 统一处理 API 响应错误（适用于普通请求和轮询）
 * @param {Object} res - 接口响应对象（需包含 res.code）
 * @param {{ fromPolling?: boolean }} options - 额外选项
 * @returns {boolean} 是否已处理（如跳转登录）
 */
export function handleApiError(res, { fromPolling = false } = {}) {
  if (!res || typeof res.code !== 'number') return false;
  
  if(res.code != 20000) {
    window.$tracker.sendError({
      errorMessage: JSON.stringify(res),
      errorType: 'network',
      errorStack: 'Error stack trace...'
    });
    res.message && Toast({
      message: res.message,
      position: "bottom",
      duration: 3 * 1000
    });
    
  }

  // token 过期 (20006) 或 无医院ID (20012)
  if (res.code === 20006 || res.code === 20012) {
    if (!redirectPending) {
      redirectPending = true;

      // 清除登录信息，函数内部已实现销毁所有订阅
      myJsTools.clearLogInfo(store);

      // 如果是轮询触发，销毁所有订阅
      if (fromPolling) {
        // import('@/utils/worker/manager').then(module => {
        //   module.destroyAllPolling();
        // });
      }

      // 跳转登录
      router.replace('/login').catch(err => {});

      setTimeout(() => {
        redirectPending = false;
      }, 1000);
    }
    return true;
  }
  return false;
}
